import React from "react";
import PropTypes from "prop-types";
import { FluentTabList } from "../../../../components/FluentUI/Fluent-TabList";
import FluentSpinner from "../../../../components/FluentUI/Fluent-Spinner";
import { FluentBadge } from "../../../../components/FluentUI/Fluent-Badge";

export const OrganizationMainHeader = ({
  departmentData,
  subdepartmentData,
  type,
  setType
}) => {
  const isDepartment = type === "Departments";

  const AccordionItems = () => {
    return [
      {
        Label: (
          <div className="organization-list-tab-item">
            Departments
            { isDepartment &&
              departmentData?.isLoading ?
                <FluentSpinner appearance="primary"/>
              :
                departmentData?.data?.length > 0 &&
                <FluentBadge
                  text={`${departmentData?.data?.length || ""}`}
                  appearance="filled"
                />
              }
          </div>
        ),
        Id: "Departments",
      },
      {
        Label: (
          <div className="organization-list-tab-item">
            Sub-Departments
            { !isDepartment &&
              subdepartmentData?.isLoading ?
                <FluentSpinner appearance="primary"/>
              :
                subdepartmentData?.data?.length > 0  &&
                <FluentBadge
                  text={`${subdepartmentData?.data?.length || ""}`}
                  appearance="filled"
                />
              }
          </div>
        ),
        Id: "SubDepartments",
      },
    ];
  };

  return (
    <div className="organization-tab-create" data-testid="fluent-tablist">
      <FluentTabList
        tabList={AccordionItems()}
        vertical={false}
        tabClick={(type) => {
          setType(type);
        }}
        currentTab={type}
      />
    </div>
  );
};

OrganizationMainHeader.propTypes = {
  departmentData: PropTypes.object.isRequired,
  subdepartmentData: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  setType: PropTypes.func.isRequired,
};
